import { render, staticRenderFns } from "./onBoardingSuccess.vue?vue&type=template&id=64edfdb6&scoped=true&"
import script from "./onBoardingSuccess.vue?vue&type=script&lang=ts&"
export * from "./onBoardingSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./onBoardingSuccess.vue?vue&type=style&index=0&id=64edfdb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64edfdb6",
  null
  
)

export default component.exports